import { createReducer } from "../ReduxHelpers";
import * as GLOBAL_CONSTANTS  from "../../constants/GlobalConstants";
import _ from "lodash/fp";

const modelerInitialState = {
  activeModeler: {},
  modelers: [],
  loading: false,
  cloneStatus: false,
  total: 0,
  error: false,
  publishReportStatus: GLOBAL_CONSTANTS.REQUEST_STATUS.NONE,
  publishReportError: false,
  publishReportErrorMessage: '',

};

function setactiveModeler(state, action) {
  let newState = {...state};
  newState.activeModelerId = action.payload.id;
  return newState;
}

function fetchModelersBegin(state, action) {
  let newState = {...state};
  newState.cloneStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.NONE;
  newState.deleteStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.NONE;
  newState.activeModeler = {};
  newState.activeModelerId = -1;
  newState.isLoading = true; 
  newState.searchError = false;
  newState.searchErrorMessage = '';
  return newState;
}

function fetchModelersSuccess(state, action) {
  let newState = {...state};
  newState.modelersList = [...action.payload.listModelers.items];
  newState.total = action.payload.listModelers.total;
  newState.isLoading = false; 
  return newState;
}
function fetchModelerFailure(state, action) {
  let newState = {...state};
  newState.isLoading = false;
  newState.searchError = true;
  newState.searchErrorMessage = action.payload;
  return newState;
}
function fetchModelerByIdBegin(state, action) {
  let newState = {...state};
  newState.cloneStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.NONE;
  newState.deleteStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.NONE;
  newState.activeModeler = {};
  newState.activeModeler.isLoading = true; 
  newState.activeModeler.fetchError = false;
  newState.activeModeler.fetchErrorMessage = '';  
  return newState;
}

function fetchModelerByIdSuccess(state, action) {
  let newState = {...state};

  newState.activeModeler = {...action.payload.getModeler};

  // Sort inputGroups by label
  if (newState.activeModeler.inputGroups && newState.activeModeler.inputGroups.length > 0) {
    newState.activeModeler.inputGroups.sort((a, b) => a.label.localeCompare(b.label));

    // Sort inputItems within each inputGroup
    newState.activeModeler.inputGroups.forEach(group => {
      if (group.inputItems && group.inputItems.length > 0) {
        group.inputItems.sort((a, b) => a.label.localeCompare(b.label));
      }
    });
  }

  // Check if getModeler.modelRuns has items and set activeModelRunId to the id of the first item
  if (action.payload.getModeler.modelRuns && action.payload.getModeler.modelRuns.items.length > 0) {
    newState.activeModeler.activeModelRunId = action.payload.getModeler.modelRuns.items[0].id;
  }

  newState.activeModeler.isLoading = false; 
  return newState;
}

function fetchModelerByIdFailure(state, action) {
  let newState = {...state};
  newState.activeModeler.isLoading = false;
  newState.activeModeler.fetchError = true;
  newState.activeModeler.fetchErrorMessage = action.payload;
  return newState;
}
function cloneModelerBegin(state, action) {
  let newState = {...state};  
  newState.cloneStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  newState.cloneError = false;
  newState.cloneErrorMessage = '';
  return newState;
}
function cloneModelerSuccess(state, action) {
  let newState = {...state};
  newState.activeModeler = {...action.payload.cloneModeler};
  newState.cloneStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS;
  return newState;  
}

function cloneModelerFailure(state, action) {
  let newState = {...state};
  newState.cloneStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE;
  newState.cloneErrorMessage = action.payload;
  return newState;
}


function createUpdateModelerBegin(state, action) {
  let newState = {...state};
  return newState;
}

function createUpdateModelerSuccess(state, action) {
  let newState = {...state};
  console.log(newState);
  return newState;
}

function deleteModelerBegin(state, action) {
  let newState = {...state};
  newState.deleteStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  newState.deleteError = false;
  newState.deleteErrorMessage = '';
  return newState;
}

function deleteModelerSuccess(state, action) {
  let newState = {...state};  
  newState.deleteStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS;
  newState.deleteError = false;
  newState.deleteErrorMessage = '';
  newState.activeModeler = {};
  newState.activeModelerId = "";
  return newState;
}
function deleteModelerFailure(state, action) {
  let newState = {...state};
  newState.deleteStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE;
  newState.deleteError = true;
  newState.deleteErrorMessage = action.payload;
  return newState;
}
function updateModelerThumbnailImage(state, action) {
  let newState = {...state};
  newState.activeModeler.thumbnailImage = action.payload.imageUrl;
  return newState;
}

function updateModelerBegin(state, action) {
  let newState = {...state};
  newState.updateStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  newState.updateError = false;
  newState.updateErrorMessage = '';
  return newState;
}

function updateModelerSuccess(state, action) {
  let newState = {...state};
  newState.updateStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS;
  newState.updateError = false;
  newState.updateErrorMessage = '';
  return newState;
}

function updateModelerFailure(state, action) {
  let newState = {...state};
  newState.updateStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE;
  newState.updateError = true;
  newState.updateErrorMessage = action.payload;
  return newState;
}

// New reducer functions for publishing modeler reports
function publishModelerReportBegin(state, action) {
  let newState = {...state};
  newState.publishReportStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  newState.publishReportError = false;
  newState.publishReportErrorMessage = '';
  return newState;
}

function publishModelerReportSuccess(state, action) {
  let newState = {...state};
  newState.publishReportStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS;
  newState.publishReportError = false;
  newState.publishReportErrorMessage = '';
  if (newState.activeModeler) {
    newState.activeModeler = {
      ...newState.activeModeler,
      generatedReportId: action.payload
    };
  }
  return newState;
}

function publishModelerReportFailure(state, action) {
  let newState = {...state};
  newState.publishReportStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE;
  newState.publishReportError = true;
  newState.publishReportErrorMessage = action.payload;
  return newState;
}

function resetErrors(state, action) {
  let newState = {...state};
  newState.error = false;
  newState.errorMessage = '';
  newState.searchError = false;
  newState.searchErrorMessage = '';
  newState.cloneError = false;
  newState.cloneErrorMessage = '';
  newState.fetchError = false;
  newState.fetchErrorMessage = '';
  newState.deleteError = false;
  newState.deleteErrorMessage = '';
  newState.updateError = false;
  newState.updateErrorMessage = '';
  newState.publishReportError = false;
  newState.publishReportErrorMessage = '';
  return newState;
}

export const modelerReducers = createReducer(modelerInitialState, {
  RESET_ERRORS_ACTION: resetErrors,
  SET_SELECTED_MODELER_ACTION: setactiveModeler,
  FETCH_MODELERS_SUCCESS_ACTION: fetchModelersSuccess,
  FETCH_MODELERS_FAILURE_ACTION: fetchModelerFailure,
  FETCH_MODELERS_BEGIN_ACTION: fetchModelersBegin,
  FETCH_MODELER_BY_ID_BEGIN_ACTION: fetchModelerByIdBegin, 
  FETCH_MODELER_BY_ID_SUCCESS_ACTION: fetchModelerByIdSuccess,
  FETCH_MODELER_BY_ID_FAILURE_ACTION: fetchModelerByIdFailure,
  CREATE_UPDATE_MODELER_BEGIN_ACTION: createUpdateModelerBegin,
  CREATE_UPDATE_MODELER_SUCCESS_ACTION: createUpdateModelerSuccess,
  DELETE_MODELER_BEGIN_ACTION: deleteModelerBegin,
  DELETE_MODELER_SUCCESS_ACTION: deleteModelerSuccess,
  DELETE_MODELER_FAILURE_ACTION: deleteModelerFailure,
  CLONE_MODELER_SUCCESS_ACTION: cloneModelerSuccess,
  CLONE_MODELER_BEGIN_ACTION: cloneModelerBegin,
  CLONE_MODELER_FAILURE_ACTION: cloneModelerFailure,
  UPDATE_MODELER_THUMBNAIL_IMAGE_ACTION: updateModelerThumbnailImage,
  UPDATE_MODELER_BEGING_ACTION: updateModelerBegin,
  UPDATE_MODELER_SUCCESS_ACTION: updateModelerSuccess,
  UPDATE_MODELER_FAILURE_ACTION: updateModelerFailure,
  PUBLISH_MODELER_REPORT_BEGIN_ACTION: publishModelerReportBegin,
  PUBLISH_MODELER_REPORT_SUCCESS_ACTION: publishModelerReportSuccess,
  PUBLISH_MODELER_REPORT_FAILURE_ACTION: publishModelerReportFailure,
});
